import queryString from "query-string";

import { ECONTRACT } from "constants/actionTypes";

import { getLivestockSaleId } from "lib/navigation";
import { serializeEContract } from "lib/serializers/eContracts";

import {
  offlineActionCreator,
  offlineSubActionCreator,
  urlCheckAndAddIdAndAction,
} from "./lib";

interface UrlCreatorProps {
  id?: string;
  action?: string;
  changesSince?: number;
  livestockSaleId?: number;
}

const urlCreator = ({
  action,
  changesSince,
  livestockSaleId,
  id,
}: UrlCreatorProps = {}) => {
  return queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction(`/v2/econtracts/`, id, action),
    query: {
      changesSince,
      livestock_sale_id: livestockSaleId,
    },
  });
};

export const EContractAction = offlineActionCreator(
  ECONTRACT,
  serializeEContract,
  urlCreator,
  true,
);

export interface EContractVoidPayload {
  id: string;
}

EContractAction.void = offlineSubActionCreator(
  ECONTRACT.VOID,
  (payload: EContractVoidPayload) =>
    urlCreator({
      id: payload.id,
      action: "void",
      livestockSaleId: getLivestockSaleId(),
    }),
);

export interface EmailRecipientMeta {
  id: number;
  type: string;
}

export interface EContractEmailPayload {
  econtract_id: string;
  party: string;
  email_recipients: EmailRecipientMeta[];
  raw_email_address: string;
  business_user_ids: number[];
}

EContractAction.email = offlineSubActionCreator(
  ECONTRACT.EMAIL,
  (payload: EContractEmailPayload) =>
    urlCreator({
      id: payload.econtract_id,
      action: "email",
      livestockSaleId: getLivestockSaleId(),
    }),
);
